<template>
  <div class="success-panel">
    <img
      class="mx-auto d-block mb-3"
      src="../../../images/onboarding-app-preview.png"
      alt="HiiKER app preview"
      width="170"
    >

    <h2 class="success-heading text-center">
      Get the best experience on the <span class="success-heading__accent">HiiKER App</span>
    </h2>

    <p class="success-body text-center mb-1">
      <strong>Plan, map</strong> and <strong>track</strong>
      your hikes on the go, with the essential hiking toolkit.
      <strong>Download the app now!</strong>
    </p>

    <p class="d-flex justify-content-center mb-3">
      <span class="text-yellow d-flex align-items-center">
        <span class="mr-2 display-5">4.7</span>
        <span class="material-icons">grade</span>
        <span class="material-icons">grade</span>
        <span class="material-icons">grade</span>
        <span class="material-icons">grade</span>
        <span class="material-icons">grade</span>
      </span>
    </p>

    <!-- Dynamic sign-in QR (desktop/tablet only — scanning the same phone's screen is pointless). -->
    <div class="d-none d-md-block mb-3">
      <MobileLoginQRInline />
    </div>

    <div class="row d-flex align-items-center">
      <div class="col">
        <a
          target="_blank"
          href="https://play.google.com/store/apps/details?id=com.waymarkedtrails.hiiker&hl=en_IE&gl=US"
        >
          <img
            class="img-fluid"
            src="../../../images/google-play-btn-white.png"
            alt="Get HiiKER on Google Play"
          >
        </a>
      </div>
      <div class="col">
        <a
          target="_blank"
          href="https://apps.apple.com/ie/app/hiiker-hiking-trails/id1470810597"
        >
          <img
            class="img-fluid"
            src="../../../images/app-app-store-btn-white.png"
            alt="Download HiiKER on the App Store"
          >
        </a>
      </div>
    </div>

    <!-- Way out for users who don't want to install the app right now.
         Without this CTA the page reads as "you must continue on mobile",
         which the modal isn't actually asking for. On the modal flow this
         hides the dialog; on the standalone /login page it redirects to
         the post-login destination (or homepage). -->
    <div class="success-actions">
      <button
        type="button"
        class="btn pro-btn pro-btn--accent w-100"
        @click="continueOnWebsite"
      >
        <span class="material-icons">arrow_forward</span>
        Continue on website
      </button>
      <p class="success-note text-center">
        You can always download the app later from your account.
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Modal } from 'bootstrap';
import MobileLoginQRInline from '../../mobile_login_qr/MobileLoginQRInline.vue';

export default defineComponent({
  name: 'OnBoardingSuccessPage',
  components: { MobileLoginQRInline },
  methods: {
    continueOnWebsite() {
      // Standalone /login page: there's no modal, so redirect to whatever the
      // user was trying to reach (or the homepage). Mirrors the post-login
      // routing in OnBoardingModule's setNextPostLoginPage().
      if (this.$store.state.onBoarding.standaloneMode) {
        const stored = sessionStorage.getItem('redirectAfterLogin');
        if (stored) {
          sessionStorage.removeItem('redirectAfterLogin');
          window.location.href = stored;
        } else {
          window.location.href = '/';
        }
        return;
      }

      // Modal flow: just close the dialog and let the user carry on with
      // whatever page they triggered the signup from.
      const element = document.getElementById('on-boarding-dialog');
      const modal = element ? Modal.getInstance(element) : null;
      modal?.hide();
    },
  },
});
</script>

<style scoped>
.success-panel {
  display: flex;
  flex-direction: column;
}

.success-heading {
  font-family: 'Montserrat', Helvetica, Arial, sans-serif;
  font-size: clamp(1.4rem, 2.4vw, 1.75rem);
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: -0.01em;
  color: #fff;
  margin: 0 0 0.5rem;
}
.success-heading__accent {
  color: var(--yellow, #fddf00);
  text-shadow: 0 0 24px rgba(253, 223, 0, 0.35);
}

.success-body {
  color: #a1a4ad;
  font-size: 0.95rem;
  line-height: 1.55;
  margin-bottom: 0.5rem;
}

.success-actions {
  margin-top: 1.5rem;
  padding-top: 1.25rem;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}
.success-note {
  margin: 0.75rem 0 0;
  color: #a1a4ad;
  font-size: 0.8rem;
}
</style>
